export default __webpack_public_path__ + "static/media/patient_man.c9188ae4.svg";